module.exports = __webpack_public_path__ + "images/33c7087e9896acc3c337a0cb35272c44.jpg";